import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/services/common/common.service';

@Component({
  selector: 'app-policy-home',
  templateUrl: './policy-home.component.html',
  styleUrls: ['./policy-home.component.scss']
})
export class PolicyHomeComponent implements OnInit {

  constructor(public commonService: CommonService) { }

  ngOnInit(): void {
  }

  /**
   * Navigates to content
   * @param isPrivacyPolicy 
   */
  navigateToContent(isPrivacyPolicy: any){
    this.commonService.navigateToPage('/policy-terms', { 'ispolicy': isPrivacyPolicy})
  }

  /**
   * Accepts privacy policy
   */
  acceptPrivacyPolicy(){
    localStorage.setItem("policyAgree", "true")
    this.commonService.navigateToPage('/app-disclaimer')
  }
}
